const slugify = require('slugify');

module.exports = {};

module.exports['shuffle'] = function(a) {
  let arr = a;
  let i = 0, j = 0, temp = null;

  for (i = arr.length - 1; i > 0; i -= 1) {
    j = Math.floor(Math.random() * (i + 1));
    temp = arr[i];
    arr[i] = arr[j];
    arr[j] = temp;
  }

  return arr;
}

module.exports['randomElement'] = function(arr) {
  return arr[Math.floor(Math.random() * (arr.length - 1))];
}

module.exports['postData'] = async function(url = '', data = {}) {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    referrer: 'no-referrer',
    body: JSON.stringify(data)
  });

  return await response.json();
};

module.exports['getData'] = async function(url = '') {
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    referrer: 'no-referrer',
  }).catch(error => {
    console.error(error);
    return { 'error': true };
  });

  if (!response.ok) {
    return { 'error': true };
  }

  return await response.json();
};

module.exports['preparedCollectionTaxonomyLabels'] = function(collectionData, medium, taxon) {
  let collections = collectionData.edges;

  if (medium !== 'All') {
    collections = collections.filter(({ node }) => node.data.Medium === medium);
  }

  let taxonValues = collections.map(({ node }) => node.data[taxon]);
  taxonValues = taxonValues.reduce((acc, val) => { return acc.concat(val); }, []);
  taxonValues = taxonValues.filter((val, idx, self) => self.indexOf(val) === idx);
  taxonValues = taxonValues.sort();

  return taxonValues;
}

module.exports['preparedSourceSlugsForCollections'] = function(collectionData) {
  let sourceSlugs = collectionData.edges.map(({ node }) => node.data.Sources);
  sourceSlugs = sourceSlugs.reduce((acc, val) => { return acc.concat(val); }, []);
  sourceSlugs = sourceSlugs.map(source => {
    if (source && source.data) {
      if (source.data.Umbrella_Slug) {
        return source.data.Umbrella_Slug[0];
      }
      return source.data.Slug;
    }

    return null;
  });
  sourceSlugs = sourceSlugs.filter((val, idx, self) => self.indexOf(val) === idx);
  sourceSlugs = sourceSlugs.filter(val => val);
  sourceSlugs = sourceSlugs.sort();

  return sourceSlugs;
}

module.exports['preparedCategories'] = function(categoryData) {
  let categories = categoryData.edges.map(({ node }) => node.data.Categories);
  categories = categories.reduce((acc, val) => { return acc.concat(val); }, []);
  categories = categories.filter((val, idx, self) => self.indexOf(val) === idx);
  categories = categories.filter(val => val);
  categories = categories.sort();

  return categories;
}

module.exports['preparedTags'] = function(tagData) {
  let tags = tagData.edges.map(({ node }) => node.data.Tags);
  tags = tags.reduce((acc, val) => { return acc.concat(val) }, []);
  tags = tags.filter((val, idx, self) => self.indexOf(val) === idx);
  tags = tags.filter(val => val !== null);
  tags = tags.filter(val => val.data.Link_Count > 1);
  tags = tags.sort((a, b) => {
    if (a.data.Slug > b.data.Slug) {
      return -1;
    }

    if (b.data.Slug > a.data.Slug) {
      return 1;
    }

    return 0;
  });
  
  return tags.map(({ data }) => data.Slug);
}

module.exports['buildSlugTable'] = function(names) {
  let uniqueNames = names.filter((val, idx, self) => self.indexOf(val) === idx);
  uniqueNames = uniqueNames.filter(val => val !== null);
  uniqueNames = uniqueNames.sort();

  return uniqueNames.map(name => { return { label: name, slug: slugify(name).toLowerCase() }});
}

module.exports['shuffleArray'] = function(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }

  return a;
}